var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 16 17",
        fill: "nome",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M14 11.9766V14.9766H2V11.9766H0V14.9766C0 16.0766 0.9 16.9766 2 16.9766H14C15.1 16.9766 16 16.0766 16 14.9766V11.9766H14ZM13 7.97656L11.59 6.56656L9 9.14656V0.976562H7V9.14656L4.41 6.56656L3 7.97656L8 12.9766L13 7.97656Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }